export default __webpack_public_path__ + "static/media/pseudonymjones2.6f9b6ece.jpeg";